import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/firebaseConfig';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to refresh user data
  const refreshUser = async (user) => {
    if (!user) {
      setCurrentUser(null);
      setLoading(false);
      return;
    }

    try {
      const userRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const userData = userSnap.data();
        // ตั้ง role จาก Firestore เท่านั้น (ไม่ตั้ง default)
        setCurrentUser({ ...user, role: userData.role || null });
      } else {
        // ถ้ายังไม่มี user document ใน Firestore ให้ role เป็น null
        // เพื่อให้ไปหน้า register เลือก role
        setCurrentUser({ ...user, role: null });
      }
    } catch (error) {
      console.error('Error fetching user role:', error);
      // ถ้า error ก็ให้ role เป็น null เพื่อให้ไปหน้า register
      setCurrentUser({ ...user, role: null });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Set timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      if (loading) {
        console.warn('Auth loading timeout, setting loading to false');
        setLoading(false);
      }
    }, 10000); // 10 seconds timeout

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        await refreshUser(user);
        
        if (!user) {
          // ล้างข้อมูล localStorage เมื่อ logout
          localStorage.removeItem('bookingsData');
          localStorage.removeItem('bookingsLastFetch');
        }
      } catch (error) {
        console.error('Error in auth state change:', error);
        setLoading(false);
      }
    });

    return () => {
      clearTimeout(timeoutId);
      unsubscribe();
    };
  }, []);

  const value = {
    currentUser,
    loading,
    refreshUser: (user) => refreshUser(user || auth.currentUser),
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};